import * as React from 'react';
import { Select, MenuItem } from '@mui/material';
function ColumnValueSelect(_a) {
    var _b = _a.includeBlank, includeBlank = _b === void 0 ? false : _b, _c = _a.error, error = _c === void 0 ? false : _c, _d = _a.multiple, multiple = _d === void 0 ? false : _d, value = _a.value, items = _a.items, onChange = _a.onChange;
    var handleChange = React.useCallback(function (event) {
        onChange(event.target.value);
    }, [onChange]);
    return (React.createElement(Select, { multiple: multiple, error: error, value: value, onChange: handleChange },
        includeBlank && React.createElement(MenuItem, { value: "" }, "(blank)"),
        items.map(function (_a) {
            var text = _a.text, value = _a.value;
            return (React.createElement(MenuItem, { key: value, value: value }, text));
        })));
}
export default ColumnValueSelect;
